import { render, staticRenderFns } from "./AdminSchedulesCalendar.vue?vue&type=template&id=677a2685&scoped=true"
import script from "./AdminSchedulesCalendar.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a2685",
  null
  
)

export default component.exports